module.exports = __webpack_public_path__ + "img/e-naira.4992ca7a.svg";